import React, { useEffect, useState } from "react";
import "./ThinksToDo.scss";
import {
  CalendarTodayGreen,
  CheckInUserImage,
  LikeIcon,
} from "../../assets/images";
import CustomizedAvatar from "../commons/CircularAvatar/CustomizedAvatar";
import { LoginResponseType } from "../../redux/auth/authTypes";
import BoxLoader from "../commons/BoxLoader/BoxLoader";
import moment from "moment";
import { GetCheckInDetailDataType } from "../../redux/mySpace/mySpaceTypes";

interface TabsType {
  name: string;
  label: string;
  display: boolean | undefined;
}
const tabs: TabsType[] = [
  {
    name: "Upcoming Check-Ins",
    label: "upcoming_check_ins",
    display: true,
  },
  {
    name: "Previous Check-Ins",
    label: "previous_check_ins",
    display: true,
  },
];

type AppProps = {
  checkInScheduleList: GetCheckInDetailDataType[] | [];
  handleFeedBackModal: (data?: string) => void;
  history: any;
  loginData: LoginResponseType;
  thinksToDoFetching: boolean;
  isCheckinListPresent: boolean;
};
const UpcomingUsersCheckInSchedule = ({
  checkInScheduleList,
  handleFeedBackModal,
  history,
  loginData,
  thinksToDoFetching,
  isCheckinListPresent,
}: AppProps) => {
  const [activeTab, setActiveTab] = useState(tabs[0].label);
  const [upcomingCheckIns, setUpcomingCheckIns] = useState<
    GetCheckInDetailDataType[] | []
  >([]);
  const [previousCheckIns, setPreviousCheckIns] = useState<
    GetCheckInDetailDataType[] | []
  >([]);

  useEffect(() => {
    const previousFilterData: GetCheckInDetailDataType[] = [];
    const futureFilterData: GetCheckInDetailDataType[] = [];
    checkInScheduleList?.map((el: GetCheckInDetailDataType) => {
      const currentMoment = moment();
      const submitFeedback = currentMoment.isAfter(
        moment(`${el?.date} ${el?.end_time}`, "DD-MM-YYYY hh:mmA")
      );
      if (!submitFeedback) {
        futureFilterData.push(el);
      } else if (submitFeedback) {
        previousFilterData?.push(el);
      }
    });
    futureFilterData?.length
      ? setUpcomingCheckIns([...futureFilterData])
      : setUpcomingCheckIns([]);
    previousFilterData?.length
      ? setPreviousCheckIns([...previousFilterData])
      : setPreviousCheckIns([]);
  }, [checkInScheduleList]);

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
  };

  const renderTabs = () => {
    let finalTab = tabs.map((tab: TabsType) => {
      return (
        <div
          className={tab.display ? "tab-style mr-4" : ""}
          key={tab.label}
          onClick={() => {
            handleTabChange(tab.label);
          }}
        >
          {tab.display && (
            <div
              style={{
                padding: "12px 5px 12px 5px",
                color: activeTab === tab.label ? "#dd4433" : "",
                fontSize: "14px",
              }}
              className={`tab-header ${
                activeTab === tab.label ? "active" : ""
              }`}
            >
              {tab.name}
            </div>
          )}
          <div
            className={`${
              activeTab === tab.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });

    return finalTab;
  };

  return (
    <div className="boxs scheduled-upcoming-interviews">
      {thinksToDoFetching ? (
        <BoxLoader style={{ height: "100%" }} />
      ) : (
        <>
          <div className="d-flex justify-content-between">
            <div
              className="p-4 d-flex align-items-center w-75"
              style={{ gap: "3%" }}
            >
              <div>
                <img src={CheckInUserImage} alt="user icon" />
              </div>
              <div>
                <p className="m-0" style={{ color: "#7c8db0" }}>
                  Manager Check-Ins
                </p>
                <p
                  className="m-0"
                  style={{ fontSize: "14px", fontWeight: 600 }}
                >
                  Scheduled Check-Ins ...
                </p>
              </div>
            </div>
            {isCheckinListPresent && (
              <div className="d-flex align-items-center p-4">
                <span
                  className="mr-3"
                  style={{
                    textDecoration: "underline",
                    color: "#dd4433",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    history.push({
                      pathname: `/my-space/check-in-list`,
                      state: { activeTab: "allCheckInList" },
                    });
                  }}
                >
                  View All
                </span>
              </div>
            )}
          </div>
          <div className="d-flex pl-3">{renderTabs()}</div>
          <hr className="m-0"></hr>
          <div style={{ overflow: "auto", height: "70%" }}>
            {upcomingCheckIns?.length > 0 && activeTab === "upcoming_check_ins"
              ? upcomingCheckIns?.map((el: any) => {
                  const specifiedMoment = moment(
                    `${el?.date} ${el?.start_time}`,
                    "DD-MM-YYYY hh:mmA"
                  );
                  const currentMoment = moment();
                  const submitFeedback = currentMoment.isAfter(
                    moment(`${el?.date} ${el?.end_time}`, "DD-MM-YYYY hh:mmA")
                  );
                  const result = currentMoment.isAfter(specifiedMoment);
                  return (
                    <div>
                      {/* {setUpcomingCheckIns(false)} */}
                      <div
                        className="d-flex align-items-center p-3"
                        style={{ gap: "3%" }}
                      >
                        <div>
                          <CustomizedAvatar
                            name={`${el?.updated_by?.first_name} ${
                              el?.updated_by?.last_name
                                ? el?.updated_by?.last_name
                                : ""
                            }`}
                            image={el?.updated_by?.profile_pic?.file_url}
                            style={{ width: "58px", fontSize: "21px" }}
                          />
                        </div>
                        <div>
                          <div>
                            <p
                              className="mt-0 mb-1"
                              style={{
                                color: "#262a44",
                                fontSize: "16px",
                                fontWeight: 500,
                                marginBottom: "-2px",
                              }}
                            >
                              {`${el?.updated_by?.first_name} ${
                                el?.updated_by?.last_name
                                  ? el?.updated_by?.last_name
                                  : ""
                              }`}
                            </p>
                            <p
                              style={{
                                margin: "0px",
                                fontSize: "14px",
                                color: "#6e7491",
                              }}
                            >
                              {`${
                                el?.updated_by?.job_title
                                  ? el?.updated_by?.job_title
                                  : ""
                              } ${
                                el?.updated_by?.job_title &&
                                el?.updated_by?.department
                                  ? "|"
                                  : ""
                              } ${
                                el?.updated_by?.department
                                  ? el?.updated_by?.department
                                  : ""
                              }`}
                            </p>
                          </div>
                          <div
                            style={{
                              color: "#28a745",
                              display: "flex",
                              alignItems: "center",
                              fontWeight: 500,
                            }}
                          >
                            <img src={CalendarTodayGreen} alt="calender-icon" />{" "}
                            <div className="ml-2">
                              {el?.date}
                              <span>{` ${el?.start_time}`}</span>
                            </div>
                          </div>
                          <button
                            className="btn btn-primary mt-2"
                            onClick={() => handleFeedBackModal(el?._id)}
                            disabled={!result}
                          >
                            Start Check-In
                          </button>
                        </div>
                      </div>
                      <hr></hr>
                    </div>
                  );
                })
              : activeTab === "upcoming_check_ins" && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "70%",
                      flexDirection: "column",
                    }}
                  >
                    <img src={LikeIcon} alt="like-icon" />
                    <div
                      className="mt-3"
                      style={{
                        fontSize: "19px",
                        fontWeight: 600,
                        textAlign: "center",
                      }}
                    >
                      No Upcoming Check-ins Schedule is there!
                    </div>
                  </div>
                )}
            {previousCheckIns?.length > 0 && activeTab === "previous_check_ins"
              ? previousCheckIns?.map((el: any) => {
                  const specifiedMoment = moment(
                    `${el?.date} ${el?.start_time}`,
                    "DD-MM-YYYY hh:mmA"
                  );
                  const currentMoment = moment();
                  const submitFeedback = currentMoment.isAfter(
                    moment(`${el?.date} ${el?.end_time}`, "DD-MM-YYYY hh:mmA")
                  );
                  const result = currentMoment.isAfter(specifiedMoment);
                  return (
                    <div>
                      <div
                        className="d-flex align-items-center p-3"
                        style={{ gap: "3%" }}
                      >
                        <div>
                          <CustomizedAvatar
                            name={`${el?.updated_by?.first_name} ${
                              el?.updated_by?.last_name
                                ? el?.updated_by?.last_name
                                : ""
                            }`}
                            image={el?.updated_by?.profile_pic?.file_url}
                            style={{ width: "58px", fontSize: "21px" }}
                          />
                        </div>
                        <div>
                          <div>
                            <p
                              className="mt-0 mb-1"
                              style={{
                                color: "#262a44",
                                fontSize: "16px",
                                fontWeight: 500,
                                marginBottom: "-2px",
                              }}
                            >
                              {`${el?.updated_by?.first_name} ${
                                el?.updated_by?.last_name
                                  ? el?.updated_by?.last_name
                                  : ""
                              }`}
                            </p>
                            <p
                              style={{
                                margin: "0px",
                                fontSize: "14px",
                                color: "#6e7491",
                              }}
                            >
                              {`${
                                el?.updated_by?.job_title
                                  ? el?.updated_by?.job_title
                                  : ""
                              } ${
                                el?.updated_by?.job_title &&
                                el?.updated_by?.department
                                  ? "|"
                                  : ""
                              } ${
                                el?.updated_by?.department
                                  ? el?.updated_by?.department
                                  : ""
                              }`}
                            </p>
                          </div>
                          <div
                            style={{
                              color: "#28a745",
                              display: "flex",
                              alignItems: "center",
                              fontWeight: 500,
                            }}
                          >
                            <img src={CalendarTodayGreen} alt="calender-icon" />{" "}
                            <div className="ml-2">
                              {el?.date}
                              <span>{` ${el?.start_time}`}</span>
                            </div>
                          </div>
                          <button
                            className="btn btn-primary mt-2"
                            onClick={() => handleFeedBackModal(el?._id)}
                            disabled={!result}
                          >
                            Submit Feedback
                          </button>
                        </div>
                      </div>
                      <hr></hr>
                    </div>
                  );
                })
              : activeTab === "previous_check_ins" && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "70%",
                      flexDirection: "column",
                    }}
                  >
                    <img src={LikeIcon} alt="like-icon" />
                    <div
                      className="mt-3"
                      style={{
                        fontSize: "19px",
                        fontWeight: 600,
                        textAlign: "center",
                      }}
                    >
                      No Previous Check-ins Schedule is there!
                    </div>
                  </div>
                )}
          </div>
        </>
      )}
    </div>
  );
};

export default UpcomingUsersCheckInSchedule;
